(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["store"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const stateSelect = document.getElementById("stateFilter");
  const citySelect = document.getElementById("cityFilter");
  const resetBtn = document.getElementById("resetFilter");
  const stores = document.querySelectorAll(".innerstore");

  const stateCityMap = {};

  // Build State → City map
  stores.forEach(store => {
    const state = store.dataset.state;
    const city = store.dataset.city;

    if (!state || !city) return;

    if (!stateCityMap[state]) {
      stateCityMap[state] = new Set();
    }
    stateCityMap[state].add(city);
  });

  // Populate State dropdown
  Object.keys(stateCityMap).sort().forEach(state => {
    const option = document.createElement("option");
    option.value = state;
    option.textContent = state;
    stateSelect.appendChild(option);
  });

  // Show all stores (default)
  function showAllStores() {
    stores.forEach(store => store.style.display = "block");
  }

  // State change → update city list only
  stateSelect.addEventListener("change", function () {
    const selectedState = this.value;

    citySelect.innerHTML = '<option value="">Select City</option>';
    citySelect.disabled = !selectedState;

    showAllStores();

    if (!selectedState) return;

    [...stateCityMap[selectedState]].sort().forEach(city => {
      const option = document.createElement("option");
      option.value = city;
      option.textContent = city;
      citySelect.appendChild(option);
    });
  });

  // City change → filter stores
  citySelect.addEventListener("change", function () {
    const selectedState = stateSelect.value;
    const selectedCity = this.value;

    if (!selectedCity) {
      showAllStores();
      return;
    }

    stores.forEach(store => {
      const match =
        store.dataset.state === selectedState &&
        store.dataset.city === selectedCity;

      store.style.display = match ? "block" : "none";
    });
  });

  // Reset button
  resetBtn.addEventListener("click", function () {
    stateSelect.value = "";
    citySelect.value = "";
    citySelect.disabled = true;
    citySelect.innerHTML = '<option value="">Select City</option>';
    showAllStores();
  });

  // Initial state
  showAllStores();
});

  } catch(e) { console.error(e); }
})();
})();
